export default {
    // 图文
    getArticles:'/cmy/sendArticleManager/listByMonthTimeArray2', //获取文章
    setTop:'/cmy/sendarticle/article/cmyarticle/stickArticle',//置顶文章
    delArticle:'cmy/sendArticleManager/delArticle', //删除文章
    articleInfo:'/cmy/sendArticleManager/getArticle',//获取文章详情
    addArticle:'cmy/sendArticleManager/articleSave', //新增文章
    saveAndriod:'cmy/sendArticleManager/savePublishToAllArticle' ,//安卓保存文章

    typeList:'/cmy/sendArticleManager/listArticleType', //分类列表
    uploadTypeIcon:'/cmy/cmy/SCommunitypic/uploadImg', //上传分类icon
    addType:'/cmy/sendArticleManager/articleTypeSave',//新增分类
    delType:'/cmy/sendArticleManager/delArticleType',//删除分类
    setTypeTop:'/cmy/sendarticle/article/cmyarticletype/stickArticleType',//置顶分类

    // 推送
    sendHistory:'/cmy/sendArticleManager/getSendhistory',//推送历史
    getCount:'cmy/sendArticleManager/getCouldSendArticalCount',//推送到公众号
    sendArticle:'cmy/sendArticleManager/sendArticleArray',//推送到小程序

    // 公众号
    sendArticleManager:'/wx/sendArticleManager/get',//小程序绑定详情
    initWechat:'wx/sendArticleManager/initwechat',//初始化微信信息
    relate:'/wx/sendArticleManager/getauthurl',//绑定公众号
    delRelate:'wx/sendArticleManager/delgzh',//注销绑定的公众号
    addAnswer:'/wx/sendArticleManager/savehyy',//添加回复
    gethyy:'wx/sendArticleManager/gethyy',//获取回复
    getCode:'wx/sendArticleManager/getForeverCode',//获取二维码图片
    downloadCode:'/wx/api/wx/downSubCode',//下载二维码
    getMenu:'/wx/sendArticleManager/getMenu',//获取菜单信息 initid post
    linkUrl:'/cmy/sendArticleManager/listUrl',//获取关联网页及小程序页面列表  urltype=common_use_link/bkkj_miniprogram_link get
    articleList:'cmy/sendArticleManager/listByMonthTimeArray',//图文列表
    checkLinkWechat:'/wx/sendArticleManager/getLinkMiniprogram' ,//查看是否关联小程序 initid/appId/miniProgramInitid get
    linkWechat:'/wx/sendArticleManager/linkMiniprogram', //关联小程序 appId/initid get
    cancelLink:'/wx/sendArticleManager/cancelLinkMiniprogram',//取消关联小程序
    saveMenu:'/wx/sendArticleManager/savewxmenu',//保存菜单 wmenu/initid

}